module.exports = __webpack_public_path__ + "img/girl.fb735cfc.svg";